import initFetchPerformance from './fetch';
import initPagePerformance from './page';
import initResourcePerformance from './resource';
import initXhrPerformance from './xhr';

import SystemOptions from '../../utils/options';

export default async function() {
  await initPagePerformance();
  initResourcePerformance();

  const options = SystemOptions.getInstance().getOptions();

  if (options.getAjaxPerformance) {
    initXhrPerformance();
  }

  if (options.getFetchPerformance) {
    initFetchPerformance();
  }
}
